module.exports = "/images/goto1.jpg?7d6b5cc60204045801e37cd79ad02e91";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/components/UI/InspirationBlock/assets/goto1.jpg
// module id = d53m
// module chunks = 0